<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="box-card" shadow="hover">
          <div class="user">
            <el-avatar
              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
              :size="130"
              class="user_img"
            >
              <!-- 当avatar中的链接访问不到时，展示img中图片 -->
              <img
                src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
              />
            </el-avatar>
            <div class="user_info">
              <p class="name">{{ userName }}</p>
              <p class="role">{{is_root==0?"超级管理员":"管理员"}}</p>
            </div>
          </div>
          <div class="login_info">
            <!-- <p>上次登录时间：<span>2022-10-1</span></p> -->
            <p>
              当前IP：<span>{{ ip }}</span>
            </p>
            <!-- <p>上次登录地点：<span>北京</span></p> -->
          </div>
        </el-card>
        <!-- <el-card style="margin-top: 20px; height: 415px" shadow="hover">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              v-for="(val, key) in tableLabel"
              :key="key"
              :prop="key"
              :label="val"
            >
            </el-table-column>
          </el-table>
        </el-card> -->
      </el-col>
      <el-col :span="16"> </el-col>
    </el-row>
  </div>
</template>

<script>
import { getData } from "@/api/index";
import * as echarts from "echarts";
import { mapState } from "vuex";
import Cookie from "js-cookie";
import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      tableData: [],
      tableLabel: {
        name: "商品",
        todayBuy: "今日购买",
        monthBuy: "本月购买",
        totalBuy: "总购买",
      },
      countData: [
        {
          name: "今日支付订单",
          value: 0,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "今日收藏订单",
          value: 0,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "今日未支付订单",
          value: 0,
          icon: "s-goods",
          color: "#5ab1ef",
        },
        {
          name: "本月支付订单",
          value: 0,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "本月收藏订单",
          value: 0,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "本月未支付订单",
          value: 0,
          icon: "s-goods",
          color: "#5ab1ef",
        },
      ],
      userName: "",
      ip: "",
      is_root:1,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  async mounted() {
    this.userName = Cookie.get("userName");
    this.is_root = Cookie.get("is_root");
    this.ip = await this.getIP();
  },
  methods: {
    async getIP() {
          const response = await axios.get("https://ipv4.icanhazip.com/");
          return response.data.replace(/\n/g, "");
    },
  },
};
</script>

<style lang="less" scoped>
.user {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  .user_img {
    margin-right: 40px;
  }
  .user_info {
    .name {
      font-size: 32px;
      margin-bottom: 10px;
    }
    .role {
      color: #999999;
    }
  }
}
.login_info {
  p {
    line-height: 28px;
    font-size: 14px;
    color: #999;

    span {
      color: #666666;
      margin-left: 60px;
    }
  }
}

.num {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .icon {
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 30px;
    color: #fff;
    text-align: center;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 15px;

    .price {
      font-size: 22px;
      margin-bottom: 10px;
      line-height: 30px;
    }
    .desc {
      font-size: 13px;
      color: #999;
      text-align: center;
    }
  }

  .el-card {
    width: 32%;
    margin-bottom: 20px;
  }
}

.graph {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .el-card {
    width: 48%;
    height: 200px;
  }
}
</style>
